var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.598 8.37 8.4 5.775 8.4-5.775V6h-16.8zm16.8 1.455-8.4 5.775-8.4-5.775V18h16.8zM2.398 18V4.8h19.2v14.4h-19.2z"
  })));
};
export default SvgEnvelope;